import React from 'react';
import mixpanel from 'mixpanel-browser';

import './FooterUnorderedList.css';

export const FooterUnorderedList = ({ title, list, currentPath = '/' }) => {
  return (
    <ul className="unordered-list-footer">
      <h4 className="footer-header-row-title">{title}</h4>
      {list.map(({ href, text }) => {
        if (href === currentPath) {
          return (
            <li className="footer-list-item" key={text}>
              <a style={{ color: 'rgb(253, 148, 0)', fontWeight: 700 }}>{text}</a>
            </li>
          );
        }
        return (
          <li className="footer-list-item" key={text}>
            <a
              href={href}
              onClick={() =>
                mixpanel.track('Footer', { path: currentPath, link: href, link_title: text })
              }
            >
              {text}
            </a>
          </li>
        );
      })}
    </ul>
  );
};
